import { Component } from '@angular/core';

@Component({
  selector: 'app-sblock-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.scss']
})
export class SblockPlansComponent {
  title = 'Elige el plan perfecto para ti';
  subtitleText = 'Accede a toda nuestra formacion con el plan que mejor se adapte a tu camino.';
  titlesColor = '#2c2c54';
  secondaryColor = '#555';

  currency = 'EUR';

  plans: Array<any> = [
    {
      name: 'Plan Basico',
      price: 0,
      price_global: 0,
      showInterval: 'Gratis',
      icon: 'https://picsum.photos/seed/plan-basico-icon/60/50',
      access_info: 'Acceso a todos los cursos gratuitos',
      description: 'Ideal para comenzar tu camino de formacion sin coste alguno. Disfruta de una seleccion de cursos introductorios.',
      selected: false
    },
    {
      name: 'Plan Mensual',
      price: 9,
      price_global: 10,
      showInterval: 'al mes',
      icon: 'https://picsum.photos/seed/plan-mensual-icon/60/50',
      access_info: 'Acceso completo a todos los cursos',
      description: 'Acceso ilimitado a todo el catalogo de cursos, certificados de finalizacion y contenido nuevo cada mes.',
      selected: true
    },
    {
      name: 'Plan Anual',
      price: 90,
      price_global: 99,
      showInterval: 'al ano',
      icon: 'https://picsum.photos/seed/plan-anual-icon/60/50',
      access_info: 'Acceso completo con dos meses gratis',
      description: 'La mejor relacion calidad-precio. Todo el contenido durante un ano con un importante ahorro frente al plan mensual.',
      selected: false
    }
  ];
}
